import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", { d: "M25.968 16.467c-2.093-5.44-9.546-5.734-7.747-13.64.134-.587-.493-1.04-1-.734-4.84 2.854-8.32 8.574-5.4 16.067.24.613-.48 1.187-1 .787-2.413-1.827-2.666-4.454-2.453-6.334.08-.693-.827-1.026-1.213-.453-.907 1.387-1.827 3.627-1.827 7 .507 7.467 6.814 9.76 9.08 10.053 3.24.414 6.747-.186 9.267-2.493 2.773-2.573 3.787-6.68 2.293-10.253m-12.373 6.706c1.92-.466 2.906-1.853 3.173-3.08.44-1.906-1.28-3.773-.12-6.786.44 2.493 4.36 4.053 4.36 6.773.107 3.373-3.546 6.267-7.413 3.093" })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", { d: "M0 0h32v32H0z" })
      ])
    ], -1)
  ]))]))
}
export default { render: render }